/* eslint-env es6 */
import { openPopup } from './util.es6';

export function startAuth (session, options = {}) {
    var popup, popupWatcher, popupResponsePromise;
    function done () {
        clearInterval(popupWatcher);
        if (popupResponsePromise && popupResponsePromise.cleanup) {
            popupResponsePromise.cleanup();
        }
        popup = null;
        popupWatcher = null;
        popupResponsePromise = null;
    }

    let url = '/chat/oauth-slack-start';
    if (options.data) {
        url += '?' + $.param(options.data);
    }
    [popup, popupWatcher] = openPopup(url, 'slack', {
        closeCallback: function () {
            if (popupWatcher) {
                if (options.onClose) {
                    options.onClose();
                }
                done();
            }
        }
    });

    popupResponsePromise = session.findMessage(function (event) {
        if (event.source !== popup) {
            return false;
        }
        return event.data;
    }).done(function (response) {
        oAuthComplete(response, popup, done, options);
    });
}
function oAuthComplete (response, popup, done, options) {
    // Popup closes itself after a timeout to allow post messages to arrive
    // but we can close it early if we've received the message.
    if (popup && !popup.closed) {
        popup.close();
    }
    if (response.success) {
        debug.log('<- [OAUTH SLACK] complete', response);
        if (options.onSuccess) {
            options.onSuccess(response);
        }
    } else {
        let message = '';
        switch (response.error) {
        case 'slack_disallowed':
            message = 'Slack workspaces aren’t available on your account';
            break;
        case 'slack_disabled':
            message = 'Slack workspaces disabled';
            break;
        case 'add_connection':
            message = 'Error adding Slack workspace';
            break;
        case 'unknown':
            message = 'Missing Slack workspace details';
            break;
        case 'state_mismatch':
            message = 'Unverified Slack authorisation';
            break;
        case 'state_invalid':
            message = 'Invalid Slack verification';
            break;
        case 'state_timeout':
            message = 'Slack authorisation timeout';
            break;
        case 'slack_error':
            // No error if canceled
            if (response.slack_error != 'access_denied') {
                message = 'Error authorising Slack workspace: ' + response.slack_error;
            }
            break;
        case 'empty':
            message = 'Missing Slack authorisation details';
            break;
        default:
            message = 'Error requesting Slack authorisation: ' + response.error;
        }
        if (message) {
            debug.warn('<- [OAUTH SLACK] error', response);
        } else {
            debug.log('<- [OAUTH SLACK] error', response);
        }
        if (options.onError) {
            options.onError(message);
        }
    }
    done();
}



// WEBPACK FOOTER //
// ./app/src/lib/slack.es6